import { useCallback, useState } from "react";
import AcademyAPI from "../services/academyService";

export const useCompleteVideo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const complete = useCallback(async (courseId, videoId) => {
        if (!courseId || !videoId) {
            throw new Error("courseId y videoId son requeridos");
        }
        setLoading(true);
        setError(null);

        try {
            const response = await AcademyAPI.completeVideo(courseId, videoId);
            return response;
        } catch (err) {
            const msg = err?.message || "Error marcando video como completado";
            setError(msg);
            throw new Error(msg);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        complete,
        loading,
        error,
    };
};
